import moment from 'moment';

import 'moment/locale/es';

moment.locale('es-es');

export function formatDate(date: string, format: string = 'DD MMM YYYY') {
  if (!date) return '';
  return moment(date).format(format);
}
